<script>
import appConfig from "@/app.config";
import TableActionButtons from "../../../components/table/table-action-buttons";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "قائمة المسؤولین",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    TableActionButtons,
  },
  data() {
    return {
      title: "قائمة المسؤولین",
      items: [
        {
          text: "مدیریت ادمین ها",
          to: { name: "admins" },
        },
      ],
      pageOptions: [10, 25, 50, 100],
      fields: [
        {
          key: "rowIndex",
          sortable: false,
          label: "صف",
        },
        {
          key: "name",
          sortable: true,
          label: "الاسم",
        },
        {
          key: "family",
          sortable: true,
          label: "الکنیة",
        },
        {
          key: "email",
          sortable: true,
          label: "البريد الإلكتروني",
          thClass: "d-none d-md-table-cell",
          tdClass: "d-none d-md-table-cell",
        },
        {
          key: "actions",
          sortable: false,
          label: "العملية",
          thClass: "d-none d-md-table-cell",
          tdClass: "d-none d-md-table-cell",
        },
      ],
      searchTimer: null,
      tableDetail: JSON.parse(JSON.stringify(this.$store.state.tables.admins)),
    };
  },
  watch: {
    "tableDetail.search"() {
      this.fetchData();
    },
    "tableDetail.sortBy"() {
      this.fetchData();
    },
    "tableDetail.sortDesc"() {
      this.fetchData();
    },
    "tableDetail.currentPage"() {
      this.fetchData();
    },
  },
  mounted() {
    if (this.tableDetail.data.length === 0) {
      this.fetchData();
    }
  },
  methods: {
    fetchData() {
      const params = {
        search: this.tableDetail.search,
        page: this.tableDetail.currentPage,
        size: this.tableDetail.perPage,
        orderField: this.tableDetail.sortBy,
        orderType: this.tableDetail.sortDesc ? "desc" : "asc",
      };
      this.$axios
        .get("admins", {
          params,
        })
        .then((res) => {
          this.tableDetail.data = res.data.data;
          this.tableDetail.totalRows = res.data.total;
          this.updateTableDetail();
        });
    },
    handleSearch() {
      this.tableDetail.currentPage = 1;
      const app = this;
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      this.searchTimer = setTimeout(() => {
        app.fetchData();
      }, 500);
    },
    updateTableDetail() {
      this.$store.commit("tables/UPDATE_TABLE_DETAIL", {
        key: "admins",
        table: JSON.parse(JSON.stringify(this.tableDetail)),
      });
    },
    itemDeleted(item) {
      this.tableDetail.data.splice(this.tableDetail.data.indexOf(item), 1);
      this.tableDetail.totalRows--;
      this.updateTableDetail();
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div>
              <router-link
                :to="{ name: 'admins.create' }"
                class="btn btn-success mb-2"
                @click="showmodal = true"
              >
                <i class="mdi mdi-plus mr-2"></i> سجل المسؤول الجدید
              </router-link>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    منظر&nbsp;
                    <b-form-select
                      v-model="tableDetail.perPage"
                      size="sm"
                      @change="fetchData"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    البحث:
                    <b-form-input
                      v-model="tableDetail.search"
                      type="search"
                      placeholder="البحث ..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableDetail.data"
                :fields="fields"
                responsive="sm"
                :per-page="0"
                :current-page="tableDetail.currentPage"
                :sort-by.sync="tableDetail.sortBy"
                :sort-desc.sync="tableDetail.sortDesc"
              >
                <template #cell(rowIndex)="data">
                  <span
                    class="d-flex align-items-center justify-content-center"
                  >
                    <span>{{
                      tableDetail.perPage * (tableDetail.currentPage - 1) +
                        data.index +
                        1
                    }}</span>
                    <b-badge
                      variant="primary"
                      v-if="!data.item._showDetails"
                      style="cursor: pointer"
                      class="ml-2 d-md-none"
                      @click="data.toggleDetails"
                    >
                      +
                    </b-badge>
                    <b-badge
                      variant="danger"
                      v-else
                      @click="data.toggleDetails"
                      class="ml-2 d-md-none"
                      style="cursor: pointer"
                    >
                      -
                    </b-badge>
                  </span>
                </template>
                <template #cell(actions)="data">
                  <table-action-buttons
                    fa-title="المسؤول"
                    permission="admin"
                    route="admins"
                    :record-id="data.item.id"
                    :delete-title="data.item.name + ' ' + data.item.family"
                    @deleted="data.itemDeleted(data.itemDeleted(data.item))"
                  >
                    <template slot="extra-buttons">
                      <router-link
                        v-permission="'read activity'"
                        title="أنشطة"
                        v-b-tooltip.hover
                        class="ml-4"
                        :to="{
                          name: 'admins.activities',
                          params: { id: data.item.id },
                        }"
                      >
                        <i class="mdi mdi-clock font-size-18 text-danger"></i>
                      </router-link>
                    </template>
                  </table-action-buttons>
                </template>
                <template slot="row-details" slot-scope="data">
                  <div
                    class="d-flex flex-column align-items-start justify-content-start"
                  >
                    <span
                      ><strong>البريد الإلكتروني: </strong
                      >{{ data.item.email }}</span
                    >
                    <table-action-buttons
                      fa-title="المسؤول"
                      permission="admin"
                      class="mt-3"
                      route="admins"
                      :record-id="data.item.id"
                      :delete-title="data.item.name + ' ' + data.item.family"
                      @deleted="fetchData"
                    >
                      <template slot="extra-buttons">
                        <router-link
                          v-permission="'read activity'"
                          title="أنشطة"
                          v-b-tooltip.hover
                          class="ml-4"
                          :to="{
                            name: 'admins.activities',
                            params: { id: data.item.id },
                          }"
                        >
                          <i class="mdi mdi-clock font-size-18 text-danger"></i>
                        </router-link>
                      </template>
                    </table-action-buttons>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="tableDetail.currentPage"
                      :total-rows="tableDetail.totalRows"
                      :per-page="tableDetail.perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
